import React, { useEffect, useState } from 'react';

import Lottie from 'lottie-react';
import { useTranslation } from 'react-i18next';

import { Typography } from '@pkg/components/DesignSystem';
import { Modal } from '@pkg/components/Modal';
import { Button } from '@pkg/components/Sections/Profile/Buttons';
import { MobileInputEditCard } from '@pkg/components/Sections/Profile/MobileInputEditCard';
import { useMediaQuery } from '@pkg/providers';

import { CreatePodSuccessWrapper, HeaderWrapper, ImageWrapper, Interior } from './styles';

export interface CreatePodSuccessProps {
    onConfirm(): void;
}

const SUCCESS_CLOSE_TIMEOUT_MS = 6000;

export function CreatePodSuccess({ onConfirm }: CreatePodSuccessProps) {
    const [animationData, setAnimationData] = useState<string>();
    useEffect(() => {
        import('@pkg/lotties/rocket.json').then((module) => {
            return setAnimationData(module.default as never);
        });
    }, []);

    const { t: translate } = useTranslation(['groups']);
    const { tablet } = useMediaQuery();

    useEffect(() => {
        if (animationData) {
            const timeout = setTimeout(onConfirm, SUCCESS_CLOSE_TIMEOUT_MS);
            return () => clearTimeout(timeout);
        }
    }, [animationData, onConfirm]);

    return tablet ? (
        <Modal onClose={onConfirm} padded>
            <Modal.Layout>
                <Modal.Layout.Section>
                    <ImageWrapper>
                        <Lottie loop autoplay animationData={animationData} alt="Pod created!" />
                    </ImageWrapper>
                </Modal.Layout.Section>

                <Modal.Layout.Section padded>
                    <Typography size={40} align="center" type="headline" weight="600">
                        {translate('pod_creation_welcome')}
                    </Typography>

                    <Typography size={20} type="label" faded align="center" weight="400">
                        {translate('pod_creation_welcome_subtitle')}
                    </Typography>
                </Modal.Layout.Section>

                <Modal.Layout.Section alignEnd>
                    <Button size="medium" onClick={onConfirm}>
                        {translate('pod_creation_welcome_lets_go')}
                    </Button>
                </Modal.Layout.Section>
            </Modal.Layout>
        </Modal>
    ) : (
        // TODO: Remove `open` prop.
        <MobileInputEditCard open background="rgb(42, 38, 55)" onClose={onConfirm}>
            <CreatePodSuccessWrapper>
                <Interior>
                    <ImageWrapper>
                        {/* TODO: `alt` text should use `i18n`. */}
                        <Lottie loop autoplay animationData={animationData} alt="Pod created!" />
                    </ImageWrapper>

                    <HeaderWrapper>
                        <Typography size={30} align="center" type="headline" weight="600">
                            {translate('pod_creation_welcome')}
                        </Typography>

                        <Typography size={16} type="label" faded align="center" weight="400">
                            {translate('pod_creation_welcome_subtitle')}
                        </Typography>
                    </HeaderWrapper>
                </Interior>
            </CreatePodSuccessWrapper>
        </MobileInputEditCard>
    );
}
